export class CopyButton
{
    static animationTimeOut = 5000;

    constructor(copyButton, textToCopy)
    {
        this.copyButton = copyButton;
        this.textToCopy = textToCopy;

        this.setEventListeners();
    }

    copyToClipboard()
    {
        if (this.textToCopy) {
            return navigator.clipboard.writeText(this.textToCopy.innerText);
        }

        return Promise.resolve();
    }

    startAnimation()
    {
        this.copyButton.classList.add('copy-button--active');

        if (this.textToCopy) {
            this.textToCopy.classList.add('text-to-copy--active');
        }
    }

    endAnimation()
    {
        this.copyButton.classList.remove('copy-button--active');

        if (this.textToCopy) {
            this.textToCopy.classList.remove('text-to-copy--active');
        }

        this.copyButton.classList.add('copy-button--checked');
    }

    setEventListeners()
    {
        this.copyButton.addEventListener('click', () => {
            this.copyToClipboard().then(() => {
                this.startAnimation();
                setTimeout(() => {
                    this.endAnimation()
                }, CopyButton.animationTimeOut);
                setTimeout(() => this.endAnimation(), CopyButton.animationTimeOut);
            });
        });
    }
}